import { render, staticRenderFns } from "./IndigenousAndProtectedAreas.vue?vue&type=template&id=01b635ce"
import script from "./IndigenousAndProtectedAreas.vue?vue&type=script&lang=js"
export * from "./IndigenousAndProtectedAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports